export default __webpack_public_path__ + "static/media/water-2.ae1b893a.jpg";